import { render, staticRenderFns } from "./TotalExpense.vue?vue&type=template&id=6c56abe2"
import script from "./TotalExpense.vue?vue&type=script&lang=js"
export * from "./TotalExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c56abe2')) {
      api.createRecord('6c56abe2', component.options)
    } else {
      api.reload('6c56abe2', component.options)
    }
    module.hot.accept("./TotalExpense.vue?vue&type=template&id=6c56abe2", function () {
      api.rerender('6c56abe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/reports/TotalExpense.vue"
export default component.exports